import { API_URL } from '@/main'
import axios from "axios"

const methods = [
  {method: 'fetchBases', url: 'price_list/BasesList/'},
  {method: 'fetchCurrencies', url: 'price_list/CurrenciesList/'},
  {method: 'fetchCustomers', url: 'customers/CustomersList/'},
  {method: 'fetchFormulas', url: 'price_list/CalculationFormulasList/'},
  {method: 'fetchGoodsKinds', url: 'various/GoodsKindsList/'},
  {method: 'fetchLocations', url: 'geographic/LocationsList/'},
  {method: 'fetchMeasureUnits', url: 'various/MeasureUnitsList/'},
  {method: 'fetchPackagingKinds', url: 'various/PackagingsKindsList/'},
  {method: 'fetchPricesList', url: 'price_list/PriceListDistinct/'},
  {method: 'fetchVoices', url: 'price_list/PriceListVoicesList/'},
]

export const genericFunction = (methodName) => {
  
  console.debug("**** methodName", methodName)
  
  return async () => {
  
    try {
      
      const methodObj = methods.find((m) => m.method === methodName)
      
      if(!methodObj) {

        console.error(`Method ${methodName} not found.`)
        return null
      }

      const url = API_URL + methodObj.url
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.get(url, {headers: headers})

      return response.data
    } 
    catch (error) {
    
      console.error(`Error loading ${methodName}:`, error)
      return null
    }
  }
}


